export default "/images/2424192ed19e826df626e387aa8eb033.avif";